export default {
      id: "badge-information-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#badge-information",
      toString: function () {
        return this.url;
      }
    }